import BaseViewController from "./base-view-controller";
import extractFieldValues from "../utils/extract-field-values";

class ActivationDependentInfoViewController extends BaseViewController {
  preprocessScreenData() {
    if (this.appData.lastNavAction === "next") {
      if (this.appData.dependentStored) {
        const values = extractFieldValues(this.screen, {});
        this.appData.values = {
          ...this.appData.values,
          ...values
        };
        this.appData.resetDependent();
      }
    }
  }
}
export default ActivationDependentInfoViewController;
